<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EDITAR UBICACIÓN</h1>
             <div class="title-lists">
                {{ selectedAddress?.outsider?.identificationCode }} -
                {{ selectedAddress?.outsider?.name }}
                {{ selectedAddress?.outsider?.lastName }}
            </div>
        </div>
        <div class="form-body">
            <form [formGroup]="editAddressForm" (ngSubmit)="updateAddress()">
                <div class="line column-md-12">
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Código de territorio</mat-label>
                            <input type="number" matInput placeholder="Código de territorio"
                                formControlName="territoryCode" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editAddressForm
                                        .get('territoryCode')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Territorio</mat-label>
                            <mat-select matInput placeholder="Territorio" formControlName="territory">
                                <mat-option *ngFor="let territories of territories" [value]="territories.label">
                                    {{territories.label}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editAddressForm
                                    .get('territory')
                                    ?.hasError('required')
                                    ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Código de autoridad</mat-label>
                            <input type="number" matInput placeholder="Código de autoridad"
                                formControlName="authorityCode" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editAddressForm
                                        .get('authorityCode')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Autoridad</mat-label>
                            <input matInput placeholder="Autoridad" formControlName="authority"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editAddressForm
                                        .get('authority')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Vereda/barrio</mat-label>
                            <input matInput placeholder="Vereda/barrio" formControlName="street"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editAddressForm
                                        .get('street')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Número</mat-label>
                            <input matInput placeholder="Número" formControlName="number"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editAddressForm
                                        .get('number')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Complemento</mat-label>
                            <input matInput placeholder="Complemento" formControlName="complement"
                                oninput="this.value = this.value.toUpperCase()" />
                            <mat-error class="for-text text-danger" *ngIf="
                                    editAddressForm
                                        .get('complement')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
                </button>
                <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
                    <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
                </button>
            </form>
        </div>
    </div>
</div>
